import React, { useState, useEffect } from "react";
import { Button, Box, Autocomplete, FormControl } from "@mui/material";
import { Grid, TextField, Dialog, DialogContent } from "@mui/material";
import { Typography, InputLabel, Select, MenuItem, Stack } from "@mui/material";
import deleteIcon from "../../images/delete.png";
import backIcon from "../../images/backIcon.svg";
import { Link, useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import BillPreview from "../reusableComponents/BillPreview";
import { useDispatch, useSelector } from "react-redux";
import { createInvoice } from "./httpCalls";
import { getInvoices, increaseInvoiceNo, invoiceAdded } from "./invoiceSlice";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import { TableBody, TableHead } from "./styles";
import moment from "moment";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";
import SearchItems from "./SearchItems";
import AddItem from "./AddItem";
import { useRef } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import InvoicePrint from "./InvoicePrint";
import InvoicePrintThermal from "./InvoicePrintThermal";

import { Toast } from "../components/Toast";
import Loader from "../components/Loader";
import { ClipLoader } from "react-spinners";
import Repo from "../../Repository/Repo";
import AddLedger from "../ledgers/AddLedger";
import {
  BtnBack,
  BtnHeader,
  HeadBox,
  RowBox,
  SubTitle,
} from "../point of sale/styles";
import { saveLedger } from "../ledgers/httpCalls";
import jsPDF from "jspdf";
import { InvoiceNewPrinted } from "./InvoiceNewPrinted";
import { InvoiceNewPrintedThermal } from "./InvoiceNewPrintedThermal";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const companyCode = localStorage.getItem("companyCode");
let titleType = "";
if (companyCode == 7149) {
  titleType = "Estimate";
} else {
  titleType = "Invoice";
}

function AddInvoice() {
  const history = useHistory();
  const dispatch = useDispatch();
  const printRef = useRef();
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const { invoiceNumber } = useSelector((state) => state?.invoice);
  const [state, setState] = useState({
    date: "",
    invoiceNumber: invoiceNumber + 1,
    ledger: {},
    invoiceType: "Sale",
    total: "",
    recieved: "",
    refNumber: "",
    payType: "Cash",
    description: "",
    invoiceDate: "",
    ledgerBalance: "",
    checkBox: false,
  });

  const [ledger, setLedger] = useState({
    ledger_id: "new",
    new_ledger: {
      ledger_type: "customer",
      address: "",
      name: "",
      phoneNo: "",
      region: "",
      ledgerSelection: false,
      idString: "new",
    },
    formallyOutstandings: 0,
    fieldsHeight: "3rem",
  });
  console.log("sttt", state.invoiceType);
  console.log("stttate", state);

  const [itemModal, setItemModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [items, setItems] = useState([]);
  const [newModal, setNewModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const temp = localStorage.getItem("template");

  useEffect(() => {
    dispatch(getInvoices());

    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }

    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");

    setState((prev) => ({ ...prev, invoiceDate: `${day}-${month}-${year}` }));
  }, [ledgersNames]);

  const totalPrice = () => {
    let totalPrice = 0;
    items.map((item) => {
      let saleQty = item.saleQuantity ? item.saleQuantity : 1;
      totalPrice += item.price * saleQty;
    });
    return totalPrice;
  };
  const handleBack = () => {
    setLedger((pre) => ({
      ...pre,
      fieldsHeight: "3rem",
      new_ledger: {
        ledgerSelection: false,
        ledger_type: "customer",
        address: "",
        name: "",
      },
    }));
  };
  const handleSelection = () => {
    setLedger((pre) => ({
      ...pre,
      fieldsHeight: "8rem",
      new_ledger: {
        ledgerSelection: !pre.ledgerSelection,
        ledger_type: "customer",
        address: "",
        name: "",
        idString: "new",
      },
      formallyOutstandings: 0,
    }));
  };

  const handleNewLedger = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    if (name == "name") {
      setState((pre) => ({
        ...pre,
        ledger: value,
      }));
      setLedger((pre) => ({
        ...pre,
        // ledger: value,
        new_ledger: {
          ...pre.new_ledger,
          [name]: value,
        },
      }));
    } else {
      setLedger((pre) => ({
        ...pre,
        new_ledger: {
          ...pre.new_ledger,
          [name]: value,
        },
      }));
    }
  };
  const toggle = () => {
    // if (!state.ledger) {
    //   Toast("info", "Kindly select ledger");
    //   return;
    // }
    if (items.length == 0 && !state.total) {
      Toast("info", "Kindly add total amount");
      return;
    }
    if (state.payType == "Cheque" && !state.refNumber) {
      Toast("info", "Kindly add cheque number");
      return;
    }
    let copy = JSON.parse(JSON.stringify(state));
    copy.invoiceNumber = parseInt(invoiceNumber) + 1;
    copy._id = `${companyCode}_${invoiceNumber + 1}`;
    let date = Math.round(+new Date() / 1000);
    copy.created_at = date;
    copy.items = items;
    if (items.length > 0) {
      copy.total = totalPrice();
    }
    setState(copy);
    setModal((state) => !state);
  };

  const itemToggle = () => {
    setItemModal((state) => !state);
  };

  const handleInput = (e) => {
    console.log("ssss", e.target.value);
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    console.log("ssss", value);

    setState((state) => ({ ...state, [name]: newValue }));
  };

  const onSuccess = (item) => {
    setItems((prev) => [...prev, item]);
    setNewModal(false);
  };

  const submit = async () => {
    try {
      setLoading(true);
      let _id = uuidv4();
      let id = _id.replaceAll("-", "");
      let new_ledger = {
        _id: id,
        name: ledger.new_ledger.name,
        ledgerType: ledger.new_ledger.ledger_type,
        // address: ledger.new_ledger.address,
        // region: ledger.new_ledger.region,
        // address:"",
        // region: "",
        address: ledger.new_ledger.address,
        phoneNo: ledger.new_ledger.phoneNo,
      };
      console.log("s", state.customer);
      if (ledger.new_ledger.name) {
        const ledgerName = ledger.new_ledger.name;
        const ledgerResponse = await saveLedger(new_ledger, dispatch);
        console.log("ledgerResponse", ledgerResponse);
        if (ledgerResponse.response.status.statusCode === 200) {
          const response = await createInvoice({
            invoice: state,
            dispatch,
            toggle,
          });

          // const regex = /_(\w+)$/;
          const res = response.split("_").slice(1).join("_");
          console.log("res", res);
          // Execute regex on the response string
          // const match = response.match(regex);
          console.log("a", state.invoiceType);
          console.log("", response);

          // console.log("match", match)
          let updateType =
            state.invoiceType == "Purchase"
              ? "updatePurchaseLedger"
              : "updateSaleLedger";
          console.log("", state.total);
          console.log("r", state.recieved);

          let type = state.invoiceType.toLocaleLowerCase();
          let remaining = Number(state.total) - Number(state.recieved ?? 0);
          console.log("rec", state.recieved);

          console.log("rem", remaining);
          let entry = {
            srNum: uuidv4(),
            date: state.invoiceDate,
            detail: state.description,
            totalAmount: state.total,
            depositedAmount: state.recieved,
            remainingAmount: remaining,
            type: "invoice",
            invoiceNumber: res,
          };

          let { data } = await Repo.ledger({
            request: {
              method: updateType,
              data: {
                _id: new_ledger._id,
                [type]: entry,
              },
            },
          });
          if (data.response.data.ledger) {
            Toast("success", "Ledger Updated");
          } else {
            Toast("error", "Ledger Entry Not created");
          }
        }
      } else {
        console.log("second");
        const response = await createInvoice({
          invoice: state,
          dispatch,
          toggle,
        });

        // const regex = /_(\w+)$/;
        const res = response.split("_").slice(1).join("_");
        console.log("res", res);
        // Execute regex on the response string
        // const match = response.match(regex);
        console.log("a", state.invoiceType);
        console.log("", response);

        // console.log("match", match)
        let updateType =
          state.invoiceType == "Purchase"
            ? "updatePurchaseLedger"
            : "updateSaleLedger";
        console.log("", state.total);
        console.log("r", state.recieved);

        let type = state.invoiceType.toLocaleLowerCase();
        let remaining = Number(state.total) - Number(state.recieved ?? 0);
        console.log("rec", state.recieved);

        console.log("rem", remaining);
        console.log("date", state.invoiceDate);
        // const [day, month, year] = state.invoiceDate.split("-").map(Number);
        // const timestamp = new Date(year, month - 1, day).getTime(); // Convert to milliseconds
        // console.log(timestamp);
        // const timestampInSeconds = Math.floor(timestamp / 1000);
        const timestampInSeconds = Math.floor(Date.now() / 1000);
        console.log(timestampInSeconds);

        let entry = {
          srNum: uuidv4(),
          date: state.invoiceDate,
          date: timestampInSeconds,
          detail: state.description,
          totalAmount: state.total,
          depositedAmount: Number(state.recieved),
          remainingAmount: remaining,
          type: "invoice",
          invoiceNumber: res,
        };
        if (state.ledger._id) {
          let { data } = await Repo.ledger({
            request: {
              method: updateType,
              data: {
                _id: state.ledger._id,
                [type]: entry,
              },
            },
          });
          if (data.response.data.ledger) {
            Toast("success", "Ledger Updated");
          } else {
            Toast("error", "Ledger Not Updated");
          }
        }
      }
      if (temp == "thermal") {
        InvoiceNewPrintedThermal({ state, ledger });
      } else {
        InvoiceNewPrinted({ state, ledger });
      }

      setLoading(false);
    } catch (err) {
      console.log("err:", err);
    }
  };

  const deleteToggle = (index) => {
    let copy = JSON.parse(JSON.stringify(items));
    copy.splice(index, 1);
    setItems(copy);
  };

  const handleLedger = (e, val) => {
    console.log("vall", val);
    setState((pre) => ({
      ...pre,
      ledger: val,
    }));
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const onSelect = (item) => {
    if (item._id) {
      const { _id, name, price } = item;
      setItems((prev) => [...prev, { _id, name, price, saleQuantity: 1 }]);
    } else {
      setItems((prev) => [...prev, item]);
    }
  };
  const handleQty = (e, idx) => {
    const { value } = e.target;
    let copy = JSON.parse(JSON.stringify(items));
    copy[idx].saleQuantity = value;
    setItems(copy);
  };

  const newToggle = () => {
    setNewModal((prev) => !prev);
  };

  const onAfter = () => {
    setTimeout(() => {
      console.log("Redirecting...");
      history.push("/inventory/admin/invoices");
    }, 3000);
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", sm: "0px", xs: "60px" } }}>
        <TopGrid container alignItems="center">
          <Grid align="center" item md={10} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              {titleType}
            </Typography>
          </Grid>

          <Grid
            item
            md={2}
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Link to="/inventory/admin/invoices">
              <ButtonAdd variant="contained" fullWidth>
                Back <img src={backIcon} alt="add" />
              </ButtonAdd>
            </Link>
          </Grid>
        </TopGrid>
      </Header>

      <BodyContainer sx={{ mt: { md: "100px", sm: "160px", xs: "220px" } }}>
        <Box>
          <Grid container spacing={2} mt="10px">
            <Grid item md={2} sm={5} xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Invoice Type</InputLabel>
                <Select
                  fullWidth
                  size="small"
                  variant="outlined"
                  name="invoiceType"
                  value={state.invoiceType}
                  label="Invoice Type"
                  onChange={handleInput}
                >
                  <MenuItem value="Sale">Sale Invoice</MenuItem>
                  <MenuItem value="Purchase">Purchase Invoice</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column" },
                flexBasis: {
                  xs: "100%", // For screens smaller than md
                  md: "50%", // For md and up
                },
                maxWidth: {
                  xs: "100%", // For screens smaller than md
                  md: ledger.new_ledger.ledgerSelection ? "40%" : "20%", // For md and up
                },
                gap: "1rem",
                height: "8rem",
                pt: {
                  xs: "0px !important",
                  md: 16,
                },
                height: ledger.fieldsHeight,
              }}
            >
              {" "}
              <Box
                textAlign="center"
                sx={{ display: "flex", justifyContent: { xs: "center" } }}
              >
                {ledger.new_ledger.ledgerSelection == false && (
                  <Button
                    sx={{
                      fontSize: { md: "16px", xs: "14px" },
                      mt: "23px",
                      lineHeight: "120%",
                      textTransform: "none",
                      padding: "0px",
                    }}
                    onClick={handleSelection}
                    className="ledger-font-sm-10"
                  >
                    New Customer
                  </Button>
                )}
                {ledger.new_ledger.ledgerSelection == true && (
                  <BtnBack
                    sx={{
                      display: "flex",
                      alignItems: "flex-start", // aligns text to the top vertically
                      justifyContent: "flex-start", // aligns text to the start horizontally
                    }}
                    onClick={handleBack}
                  >
                    Back
                  </BtnBack>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { sm: "row", xs: "column" },
                  // alignItems: {  md: "start" },
                }}
              >
                {ledger.new_ledger.ledgerSelection == true && (
                  <>
                    <h4 style={{ margin: "0 auto", padding: "10px" }}>
                      Create new Customer
                    </h4>
                    <Stack spacing={1}>
                      {ledger.ledger_id === "new" && (
                        <TextField
                          size="small"
                          variant="outlined"
                          required
                          name="name"
                          value={ledger.new_ledger.name}
                          onChange={handleNewLedger}
                          placeholder="Create Customer Name"
                        />
                      )}
                      {ledger.ledger_id === "new" && (
                        <TextField
                          type="number"
                          size="small"
                          variant="outlined"
                          value={ledger.new_ledger.phoneNo}
                          required
                          name="phoneNo"
                          onChange={handleNewLedger}
                          placeholder="Phone No"
                        />
                      )}
                      {ledger.ledger_id === "new" && (
                        <TextField
                          size="small"
                          variant="outlined"
                          value={ledger.new_ledger.address}
                          required
                          name="address"
                          onChange={handleNewLedger}
                          placeholder="Address"
                        />
                      )}
                    </Stack>
                  </>
                )}

                {/* {ledger.new_ledger.ledgerSelection != true && (
              <Box > */}

                {/* {state.ledger_id != "" && state.ledger_id != "new" && (
                  <BtnHistory
                    fullWidth
                    size="small"
                    variant="contained"
                    onClick={historyToggle}
                  >
                    View item sale history
                    {state.historyModal && (
                      <VisibilityIcon style={{ marginLeft: "20px" }} />
                    )}
                    {!state.historyModal && (
                      <VisibilityOffIcon style={{ marginLeft: "20px" }} />
                    )}
                  </BtnHistory>
                )} */}
                {/* </Box>
            )} */}
              </Box>
              {/* <Box sx={{ ml: { md: "10px", xs: "20px" } }}>
            <TextField
              variant="outlined"
              multiline
              minRows={3}
              maxRows={8}
              value={state.notes}
              name="notes"
              onChange={handleInput}
              placeholder="Sale notes"
              sx={{ margin: 1, width: "90%", padding: "5px" }}
            />
          </Box> */}
            </Grid>
            <Grid
              item
              md={3}
              sm={5}
              xs={12}
              sx={{
                marginTop: {
                  xs: ledger.new_ledger.ledgerSelection ? "120px" : "16px",
                  sm: "0px",
                },
              }}
            >
              <Autocomplete
                autoFocus
                size="small"
                onChange={(e, val) => {
                  handleLedger(e, val);
                }}
                getOptionLabel={(option) => option?.name || ""}
                id="controllable-states-demo"
                options={ledgersNames}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    autoFocus
                    label="Ledger"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
            {/* <Grid item md={3} sm={5} xs={12}>
              <Autocomplete
                size="small"
                onChange={(e, val) => {
                  handleLedger(e, val);
                }}
                getOptionLabel={(option) => option?.name || ""}
                id="controllable-states-demo"
                options={ledgersNames}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ledger"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid> */}
            <Grid item md={2} sm={5} xs={12}>
              <TextField
                fullWidth
                size="small"
                type="date"
                variant="outlined"
                name="invoiceDate"
                InputLabelProps={{
                  shrink: true,
                }}
                defaultValue={getCurrentDate()}
                onChange={handleInput}
              />
            </Grid>
          </Grid>
        </Box>
        {items.length > 0 && (
          <TableHead sx={{ my: 1 }} container columns={24}>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
                ITEM
              </Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
                Sale QTY
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
                Price
              </Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
                SUB TOTAL
              </Typography>
            </Grid>
          </TableHead>
        )}
        {items.map((item, index) => {
          return (
            <TableBody key={index} container columns={24}>
              <Grid item xs={7}>
                <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
                  {item?.name}
                </Typography>
              </Grid>

              <Grid item xs={5}>
                <TextField
                  size="small"
                  type="number"
                  sx={{ width: "70%" }}
                  value={item.saleQuantity || 1}
                  onChange={(e) => handleQty(e, index)}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
                  {item?.price}
                </Typography>
              </Grid>

              <Grid item xs={5}>
                <Typography sx={{ fontSize: { md: "16px", xs: "12px" } }}>
                  {item?.saleQuantity
                    ? item.saleQuantity * item.price
                    : item.price}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <img
                  src={deleteIcon}
                  alt="delete"
                  style={{ cursor: "pointer" }}
                  onClick={() => deleteToggle(index)}
                />
              </Grid>
            </TableBody>
          );
        })}
        <Box
          sx={{
            my: 5,
            display: "flex",
            justifyContent: { xs: "center", md: "end" },
            gap: "1rem",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                name="checkBox"
                checked={state.checkBox}
                onChange={handleInput}
                color="primary"
              />
            }
            label="DayBook Entry"
          />
          {/* <AddLedger /> */}

          <Button
            variant="contained"
            sx={{ textTransform: "none" }}
            onClick={newToggle}
          >
            Add New Item
          </Button>
          <Button
            variant="contained"
            sx={{ ml: 2, textTransform: "none" }}
            onClick={itemToggle}
          >
            Search Item
          </Button>
        </Box>

        <Grid
          container
          spacing={2}
          mt="10px"
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item md={6} xs={12}>
            <Stack spacing={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Payment Type</InputLabel>
                <Select
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={state.payType}
                  name="payType"
                  label="Payment Type"
                  onChange={handleInput}
                >
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Cheque">Cheque</MenuItem>
                </Select>
              </FormControl>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
              >
                <Typography>Total Amount : </Typography>
                <TextField
                  size="small"
                  type="number"
                  variant="outlined"
                  name="total"
                  disabled={items.length > 0 ? true : false}
                  value={items.length > 0 ? totalPrice() : state.total}
                  onChange={handleInput}
                />
              </Stack>
              {state.payType == "Cash" && (
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={1}
                >
                  <Typography>Received : </Typography>
                  <TextField
                    size="small"
                    type="number"
                    variant="outlined"
                    name="recieved"
                    placeholder="received"
                    value={state.recieved}
                    onChange={handleInput}
                  />
                </Stack>
              )}
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
              >
              <Typography>Ledger Balance : </Typography>
              <TextField
                size="small"
                type="number"
                variant="outlined"
                name="ledgerBalance"
                placeholder="Ledger Balance"
                value={state.ledger.saleTotal || state.ledgerBalance}
                onChange={handleInput}
              />
              </Stack>

              {state.payType == "Cheque" && (
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={1}
                >
                  <Typography>Payment Ref No. : </Typography>
                  <TextField
                    size="small"
                    type="number"
                    variant="outlined"
                    name="refNumber"
                    placeholder="Payment Ref No."
                    value={state.refNumber}
                    onChange={handleInput}
                  />
                </Stack>
              )}
              <TextField
                size="small"
                variant="outlined"
                name="description"
                label="Description"
                multiline
                minRows={3}
                maxRows={6}
                value={state.description}
                onChange={handleInput}
              />

              <Button
                fullWidth
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={toggle}
              >
                Create {titleType}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </BodyContainer>

      {itemModal && <SearchItems onClose={itemToggle} onSelect={onSelect} />}

      {newModal && (
        <AddItem onClose={newToggle} onSuccess={(e) => onSuccess(e)} />
      )}

      {/* <Dialog open={modal} onClose={toggle} fullWidth >
        <DialogContent>
          {!loading && (
            <ReactToPrint
              // pageStyle={styles}
              onBeforePrint={submit}
              trigger={() => (
                <Button variant="contained" sx={{ textTransform: "none" }}>
                  Create Invoice
                </Button>
              )}
              onAfterPrint={onAfter}
              content={() => printRef.current}
            />
          )}
          {loading && (
            <Box sx={{ pl: 2 }}>
              <ClipLoader size={40} color="#4DAF51" loading={true} />
            </Box>
          )}
          <InvoicePrint ref={printRef} state={state} />
        </DialogContent>
      </Dialog>  */}

      {modal && (
        <Dialog open={modal} onClose={toggle} fullWidth>
          <DialogContent>
            {!loading && (
              <Button
                variant="contained"
                onClick={submit}
                sx={{ textTransform: "none" }}
              >
                Create Invoice
              </Button>
            )}
            {loading && (
              <Box sx={{ pl: 2 }}>
                <ClipLoader size={40} color="#4DAF51" loading={true} />
              </Box>
            )}
            {temp == "thermal" ? (
              <InvoicePrintThermal
                ref={printRef}
                state={state}
                ledger={ledger}
              />
            ) : (
              <InvoicePrint ref={printRef} state={state} ledger={ledger} />
            )}
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
}

export default AddInvoice;
